"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _api = require("../../api");
var _consentsHelper = _interopRequireDefault(require("../../util/consentsHelper"));
var _Header = _interopRequireDefault(require("../Header"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _Button = _interopRequireDefault(require("../Button"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _CheckoutConsentsStyled = require("./CheckoutConsentsStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CheckoutConsents = _ref => {
  let {
    onSuccess
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const [consents, setConsents] = (0, _react.useState)(null);
  const [processing, setProcessing] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [generalError, setGeneralError] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    (0, _api.getCustomerConsents)().then(resp => {
      const consentsToAccept = resp.responseData.consents.filter(consent => consent.newestVersion > consent.version || consent.needsUpdate === true);
      if (consentsToAccept.length === 0) onSuccess();else setConsents(consentsToAccept);
    }).finally(() => setIsLoading(false));
  }, []);
  const handleClick = (e, isConsentDisabled, clicked) => {
    const updatedConsents = consents.map(consent => {
      if (consent.name === clicked.name) {
        return {
          ...consent,
          state: clicked.state === 'accepted' ? 'declined' : 'accepted'
        };
      }
      return consent;
    });
    setConsents(updatedConsents);
  };
  const validateConsents = () => {
    let isError = false;
    const updatedConsents = consents.map(consent => {
      if (consent.required && consent.state === 'declined') {
        isError = true;
        return {
          ...consent,
          error: t('This consent is required')
        };
      }
      return consent;
    });
    setConsents(updatedConsents);
    return !isError;
  };
  const updateConsents = () => {
    if (validateConsents()) {
      const payload = consents.map(consent => {
        return {
          name: consent.name,
          version: consent.newestVersion,
          state: consent.state
        };
      });
      setProcessing(true);
      (0, _api.submitConsents)([], [], payload).then(() => {
        setProcessing(false);
        onSuccess();
      }).catch(() => {
        setGeneralError(t('Something went wrong. Try again later'));
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutConsentsStyled.CheckoutConsentsStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutConsentsStyled.CheckoutConsentsContentStyled, {
        children: isLoading || !consents ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutConsentsStyled.CheckoutConsentsTitleStyled, {
            children: t('Terms & Conditions')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutConsentsStyled.CheckoutConsentsSubTitleStyled, {
            children: t('Please accept Terms & Conditions')
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutConsentsStyled.CheckoutConsentsListStyled, {
            role: "list",
            children: [consents.map(consent => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckoutConsentsStyled.CheckoutConsentsCheckbox, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
                isMyAccount: true,
                onClickFn: (e, isConsentDisabled) => handleClick(e, isConsentDisabled, consent),
                checked: consent.state === 'accepted',
                required: consent.required,
                children: (0, _consentsHelper.default)(consent.label, t)
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutConsentsStyled.CheckoutConsentsError, {
                children: consent.error
              })]
            }, consent.name)), generalError && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutConsentsStyled.CheckoutConsentsError, {
              center: true,
              children: generalError
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            size: "big",
            theme: "confirm",
            onClickFn: updateConsents,
            children: processing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
              buttonLoader: true,
              color: "#ffffff"
            }) : t('Continue')
          })]
        })
      }), !isLoading && consents && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {
        isCheckout: false
      })]
    })
  });
};
CheckoutConsents.propTypes = {
  onSuccess: _propTypes.default.func
};
CheckoutConsents.defaultProps = {
  onSuccess: () => null
};
var _default = exports.default = CheckoutConsents;